import React from "react"

//スタイルシートは強制的に検索インプットのスタイリングを更新するために必要
import "./GoogleSearchStyle.css"

const search = ({ id }) => {
    const cx = id; //ここに貼り付け用コードの?cx=以下を入力
    let gcse = document.createElement('script');
    gcse.type = 'text/javascript';
    gcse.async = true;
    gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(gcse, s);
    return (

        <div className="gcse-search"></div>
    )
}

export default search